import { DialogController } from 'aurelia-dialog';

export class ViewPdfDialog {
	static inject = [DialogController];
	fileName: string;
	blobUrl: string;

	constructor(public controller, private i18n) { }

	activate(pdfData: any) {
		this.fileName = pdfData.fileName;
		this.blobUrl = pdfData.blobUrl;
	}
}